import Vue from 'vue'
import defaultState from './state'
export default {
  setIsCallingUsers: (state, payload) => { state.isCallingUsers = payload },
  setUsers: (state, payload) => {
    if (state.currentPage === 1) {
      state.users = payload
    } else {
      state.users.push(...payload)
    }
  },
  setUsersSearch: (state, payload) => {
    if (state.currentPage === 1) {
      state.usersSearch = payload
    } else {
      state.usersSearch.push(...payload)
    }
  },
  setUserLoggedData: (state, payload) => { state.userLogged = payload },
  setUsersLastPage: (state, payload) => { state.lastPage = payload },
  setUsersTotalItems: (state, payload) => { state.totalItems = payload },
  setUsersFilters: (state, payload) => {
    state.filters = payload
    state.currentPage = 1
  },
  toggleGetDeletedUsersFlag: (state) => {
    state.getDeletedUsersFlag = !state.getDeletedUsersFlag
  },
  removeUser: (state, payload) => {
    state.users = state.users.filter(el => el.id !== payload)
  },
  incrementUsersCurrentPage: state => state.currentPage++,
  setUser: (state, payload) => {
    state.user = payload
  },
  setUserLogged: (state, payload) => {
    state.userLogged = payload
  },
  setUserNotifications: (state, payload) => {
    state.userNotifications = payload
  },
  /* - USER BUDGETS- */
  setUserBudgets: (state, payload) => {
    if (state.userBudgetsCurrentPage === 1) {
      state.userBudgets = payload
    } else {
      state.userBudgets.push(...payload)
    }
  },
  updateUserList: (state, payload) => {
    const { id } = payload
    const userToUpdateIndex = state.users.findIndex(
      el => el.id === id
    )
    if (userToUpdateIndex !== -1) {
      state.users.splice(userToUpdateIndex, 1, payload)
    }
  },
  updateUser: (state, payload) => {
    state.userLogged = payload
  },
  updateUserBudget: (state, payload) => {
    const { id } = payload
    const memberToFindIndex = state.userBudgets.findIndex(el => el.id === id)
    if (memberToFindIndex !== -1) {
      state.userBudgets.splice(memberToFindIndex, 1, payload)
    }
  },
  setIsCallingUserBudgets: (state, payload) => {
    state.isCallingUserBudgets = payload
  },

  setUserBudgetsLastPage: (state, payload) => { state.userBudgetsLastPage = payload },
  setUserBudgetsCurrentPage: (state, payload) => { state.userBudgetsCurrentPage = payload },
  setUserBudgetsTotalItems: (state, payload) => { state.userBudgetsTotalItems = payload },
  incrementUserBudgetsCurrentPage: state => state.userBudgetsCurrentPage++,
  resetUserBudgets: (state) => {
    state.userBudgets = []
    state.userBudgetsCurrentPage = 1
    state.userBudgetsLastPage = 1
    state.userBudgetsTotalItems = 0
    state.isCallingUserBudgets = false
  },
  /* --- */
  addError: (state, payload) => { state.errors.push(payload) },
  clearErrors: state => { state.errors = [] },
  clearUserList: state => {
    state.users = []
    state.currentPage = 1
    state.lastPage = 1
  },
  clearUsersSearchList: state => {
    state.usersSearch = []
  },
  clearStoreData: (state, payload) => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      if (key !== payload) Vue.set(state, key, initialState[key])
    })
  }
}
